import React, { useState, useEffect } from 'react';
import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline';

const QuotesViewer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchQuotes();
    }
  }, [isOpen]);

  const fetchQuotes = async () => {
    try {
      const response = await fetch('/api/quotes');
      const data = await response.json();
      setQuotes(data);
    } catch (error) {
      console.error('Error fetching quotes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleQuoteClick = (quote) => {
    setSelectedQuote(quote);
  };

  const closeModal = () => {
    setSelectedQuote(null);
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="p-2 text-text hover:text-primary transition-colors"
        title="Voir les devis"
      >
        <DocumentIcon className="h-6 w-6" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-surface rounded-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-text">Devis Générés</h2>
              <button
                onClick={() => setIsOpen(false)}
                className="text-text hover:text-primary"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            {loading ? (
              <div className="flex-1 flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              </div>
            ) : (
              <div className="flex-1 overflow-y-auto">
                <div className="grid gap-4">
                  {quotes.map((quote) => (
                    <div
                      key={quote.id}
                      onClick={() => handleQuoteClick(quote)}
                      className="p-4 bg-surface border border-gray-700 rounded-lg cursor-pointer hover:border-primary transition-colors"
                    >
                      <div className="flex justify-between items-center">
                        <div>
                          <h3 className="text-text font-medium">{quote.number}</h3>
                          <p className="text-textSecondary text-sm">{quote.date}</p>
                        </div>
                        <div className="text-textSecondary">
                          {quote.total}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {selectedQuote && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-surface rounded-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-text">Devis {selectedQuote.number}</h2>
              <button
                onClick={closeModal}
                className="text-text hover:text-primary"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              <iframe
                src={`/devis/${selectedQuote.filename}`}
                className="w-full h-full"
                title="Quote Preview"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuotesViewer; 